import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteNames } from '@nx-ng/constants';
import { ORDERID_QUERY_PARAM } from '@nx-ng/constants/query-parameters';

const DELAY_BEFORE_REDIRECT = 2000;
@Component({
  selector: 'nx-ng-payment-success-page',
  templateUrl: './payment-success-page.component.html',
})
export class PaymentSuccessPageComponent implements OnInit {
  public constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    setTimeout(() => {
      const orderId =
        this.activatedRoute.snapshot.queryParamMap.get(ORDERID_QUERY_PARAM);
      this.router.navigateByUrl(
        `/${RouteNames.BOOKING_CONFIRMATION}?${ORDERID_QUERY_PARAM}=${orderId}`
      );
    }, DELAY_BEFORE_REDIRECT);
  }
}
